// Firebase Web SDK Configuration
// Full-stack Firebase integration: Auth, Storage, Analytics

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCZe-urklXd8VrXgQ-gZkDqS7dQdKX0Jx4",
  authDomain: "boardchat-24211.firebaseapp.com",
  projectId: "boardchat-24211",
  storageBucket: "boardchat-24211.firebasestorage.app",
  messagingSenderId: "1087165787703",
  appId: "1:1087165787703:web:4b085528114d3b4ed3d9b2",
  measurementId: "G-DQ03LG5DDK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
let analytics = null;
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Initialize Analytics in production/browser environment
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Analytics initialization failed:', error);
  }
}

export { app, analytics, db, auth, storage };
export default app;
